import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import type { IconType } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface PlanFeaturesListProps {
  className?: string;
  features: string[];
  iconColor?: string;
  iconSize?: number;
  iconType: IconType;
}

export const PlanFeaturesList = ({
  features,
  iconType,
  iconSize = 16,
  iconColor = "text-blue-highlight",
  className,
}: PlanFeaturesListProps) => {
  if (!features.length) return null;

  return (
    <ul className={classNames("flex list-none flex-col gap-3", className)}>
      {features.map((feature: string) => (
        <li key={feature} className="flex items-center gap-3">
          <Icon
            type={iconType}
            size={iconSize}
            color={undefined}
            className={classNames("!h-5 !w-5", iconColor)}
            useWithFillCurrentColor
            useWithStrokeCurrentColor
          />
          <Typography.LabelMd
            color="text-default"
            weight="normal"
            size="text-sm"
          >
            {feature}
          </Typography.LabelMd>
        </li>
      ))}
    </ul>
  );
};
